<template>
  <div>
    <div style="display: flex;" v-show="detailDialog">
      <el-input placeholder="订单id" style="width:200px;margin-right: 10px;"></el-input>
      <el-button type="primary" @click="search">搜索</el-button>
      <el-button type="warning" @click="cancel">一键撤销</el-button>
    </div>
    <div style="display: flex;" v-show="!detailDialog">
      <i class="el-icon-back" @click="goback"></i>
      <el-input placeholder="订单id" style="width:200px;margin-right: 10px;"></el-input>
      <el-button type="primary">明细搜索</el-button>
    </div>
   
    
    <el-divider></el-divider>
    <el-table :data="orderList" size="small" v-show="detailDialog">
    <el-table-column label="账户id" prop="accountId" fixed></el-table-column>
    <el-table-column label="订单id" prop="orderId" fixed width="150px"></el-table-column>
      <el-table-column  label="创建时间" width="140px">
        <template slot-scope="scope">{{
          scope.row.createdTime | moment
        }}</template>
      </el-table-column>
      <el-table-column  label="更新时间" prop='updatedTime' width="140px">
        <!-- <template slot-scope="scope">{{
          scope.row.updatedTime | moment
        }}</template> -->
      </el-table-column>
      <el-table-column  label="下单实时价格" width="140px">
        <template slot-scope="scope">{{
          scope.row.currentPrice 
        }}</template>
      </el-table-column>
     <el-table-column label="委托Id" prop="entrustId" align="center"></el-table-column>
     <el-table-column label="失效时间" prop="expireTime" width="120px" align="center"></el-table-column>
     <el-table-column label="委托类型" prop="entrustType" align="center"></el-table-column>
     <el-table-column label="messageType" prop="messageType" width="120px" align="center"></el-table-column>
     <el-table-column label="触发价格" prop="stopPrice" align="center"></el-table-column>
     <el-table-column label="symbol名" prop="symbol" align="center"></el-table-column>
     <el-table-column label="触发价格类型" prop="triggerPriceType" align="center"></el-table-column>
     <el-table-column label="下单方向" prop="orderSide" align="center">
      <template slot-scope="scope">{{
          scope.row.orderSide===1?'买入':'卖出'
        }}</template>
     </el-table-column>
     <el-table-column label="订单类型" prop="orderType">
      <template slot-scope="scope">{{
          scope.row.orderType===1?'限价':'市价'
        }}</template>
     </el-table-column>
      <el-table-column label="下单数量" prop="origQty"></el-table-column>
      <el-table-column label="下单价格" prop="price"></el-table-column>
      <el-table-column label="订单状态" >
        <template slot-scope="scope">
          <span v-if="scope.row.state===1">新建委托（未触发）</span>
          <span v-else-if="scope.row.state===2">触发中</span>
          <span v-else-if="scope.row.state===3">已触发</span>
          <spyan v-else-if="scope.row.state===4">用户撤销</spyan>
          <span v-else-if="scope.row.state===5">平台撤销（拒绝）</span>
          <span v-else>已过期</span>
          <!-- {{scope.row.state}} -->
        </template>
      </el-table-column>
      
  
      <el-table-column label="操作" fixed="right" width='210px' >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="handleCancle(scope.row)"
          >撤销订单</el-button>
          <el-button  
            size="mini"
            type="primary" 
            @click="getDetail(scope.row)" 
          >查看明细</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="pageChanged"
    ></pagination>
    <!-- <update-dialog :val="userinfoDetail" :updateForm="updateForm"></update-dialog>
    <el-dialog
      title="更新股东级别"
      :visible.sync="updateUserTypeDialogVisible"
      width="400px"
    >
      <el-select v-model="newUserType" class="user-type-select">
        <el-option
          v-for="item in Object.keys(userTypes)"
          :key="item"
          :value="item"
          :label="userTypes[item]"
        ></el-option>
      </el-select>
      <div slot="footer">
        <el-button @click="closeUserTypeDialog">取消</el-button>
        <el-button type="primary" @click="handleUpdateUserType">保存</el-button>
      </div>
    </el-dialog> -->
    <!-- 编辑用户信息dialog -->

  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import Pagination from 'components/pagination'
import updateDialog from '../updatedialog'

export default {
  name: 'UserList',
  data() {
    return {
      detailDialog: true,
      updateForm: {},
      userTypes: {
        1: '无效用户',
        2: '普通用户',
        3: '初级股东',
        4: '中级股东',
        5: '高级股东',
      },
      updateUserTypeDialogVisible: false,
      newUserType: '',
      selectedForUserType: {},
    }
  },
  components: {
    Pagination,
    updateDialog,
  },
  // computed:{
  //   ...mapState('orderPlan',['orderList'])
  // },
  methods: {
    ...mapActions('orderPlan', [
      'updateVolunteer',
      'updateBlocking',
      'cancelGoogle',
      'updateUserType',
      'updateDividendStatus',
      'getOrderList',
      'cancleOrder',
      'getOrderDetails',
    ]),
    ...mapMutations('orderPlan', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail',
    ]),
    pageChanged(pagination) {
      this.$emit('refresh', pagination)
    },
    search() {},
    //一键撤销
    cancel() {
      console.log('cancelAll---order')
    },
    goback() {
      this.detailDialog = true
    },
    //撤销订单
    handleCancle(row) {
      console.log('handleCancle', row.orderId)
      this.cancleOrder(row.orderId).then((res) => {})
    },
    //查看成交明细
    getDetail(row) {
      ;(this.detailDialog = false),
        this.getOrderDetails({
          current: 1,
          orderId: row.orderId,
          size: 25,
        }).then((res) => {})
    },
  },
  computed: {
    // ...mapGetters('orderPlan', ['orderList',]),
    ...mapState('orderPlan', [
      'pagination',
      'totalCount',
      'userinfoDetail',
      'userinfoDetailDialogVisible',
      'orderList',
    ]),
  },
  mounted() {
    this.getOrderList()
  },
}
</script>

<style lang="less" scoped>
.user-type-select {
  width: 100%;
}
.red {
  color: skyblue;
  font-weight: bold;
}
.el-icon-back:before {
  content: '\E6EA';
  font-size: 30px;
  cursor: pointer;
  line-height: 40px;
}
.el-icon-back {
  width: 40px;
  height: 40px;
}
</style>
